import React from 'react'
import { CircleFill } from 'react-bootstrap-icons'
import "../Progress.scss"
const ReportHeader = () => {
  return (
    <div className='d-flex  justify-content-between align-items-center mx-2 p-1 bg-progress-header ' style={{backgroundColor:"#CFE2F3"}} > 
                < div></div>
                       <div>
                        <h1 className='text-center text-dark' style={{fontSize:"5vh" }}>e-Adhigam</h1>
                        <h2 className='font-italic'>Haryana's Tablet Based Learning Programme</h2>
                        </div>
                    <img alt={""} className="p-2" width="110" height="110" src={require('../../../../assets/img/ProgressReportLogo/e-adhigam-progress-logo.png').default} />
                      {/* <CircleFill size={60} className="m-4"/> */}
                </div>
  )
}

export default ReportHeader
// style={{backgroundColor:"#CFE2F3"}}